import(/* webpackMode: "eager" */ "/codebuild/output/src413009145/src/ohio-university-system-frontend/components/atoms/Paragraph.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src413009145/src/ohio-university-system-frontend/components/atoms/Title.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src413009145/src/ohio-university-system-frontend/components/organisms/web-forms/session-management/PasswordRecovery.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src413009145/src/ohio-university-system-frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src413009145/src/ohio-university-system-frontend/public/assets/images/logo/logo-globallynx.png");
